// Animation timing values. Exposed for use in js-based animations.
const timing = {
  default: 200
};
const easing = {
  default: "cubic-bezier(0.3, 0.3, 0.2, 1)"
};
const animation = {
  default: `200ms ${easing.default}`
};
export const motion = {
  easing,
  animation,
  timing
};
//# sourceMappingURL=motion.js.map